export function isMeetingChangeOrganizerRequest(itemClass: string | undefined): boolean {
    return !!(itemClass && itemClass.match(/^ipm\.schedule\.meeting\.changeorganizerrequest/i));
}
